import { Input } from "@/components/ui/Input";
import { useStepContext } from "@/hooks/useSetupWizard";
import * as shared from "@/styles/shared";
import { MapPin } from "lucide-react";
import * as pageStyles from "../../pages/SetupWizardPage.styles";

const AddressStep = () => {
  const { addressName, setState, t } = useStepContext();

  return (
    <div className={pageStyles.section}>
      <h2 className={shared.headingLg}>{t("step2Title")}</h2>
      <p className={shared.muted}>{t("step2Desc")}</p>
      <div className={shared.formStack}>
        <Input
          id="address-name"
          label={t("addressName")}
          value={addressName}
          onChange={(e) => setState({ addressName: e.target.value })}
          placeholder={t("addressNamePlaceholder")}
          required
          icon={MapPin}
        />
      </div>
    </div>
  );
};

export { AddressStep };
